import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {Link, useNavigate, useParams} from 'react-router-dom'
import {sectionIndex, sectionStore} from '../../features/dashboard/SectionThreeSlice';
import Loading from '../../Loading';
import Header from './Header';
import { Calendar } from "react-multi-date-picker";
import DatePicker,{DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import SectionThreeEditModel from './SectionThreeEditModel'
import DataTable, { ExpanderComponentProps } from 'react-data-table-component';
import Broadcast from './Broadcast';
import * as Icon from 'react-feather';
import $ from 'jquery'
import { ToastContainer, toast } from 'react-toastify';
import Input from "../form/Input";
import Button from "../form/Button";
import * as moment from 'jalali-moment';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'



function ArchiveSectionThreeIndex () {
    const columns = [
        {
            name: '#',
            cell: (row, index) => <div className='rahpardaznet-border'>{index + 1} </div>,

        },
        {

            name: 'نام',
            cell: row => <div className='rahpardaznet-border'>{row.title} ({row.from != '0' ? row.from : '-'} تا {row.to != '0' ? row.to : '-'})</div>
        },

        {
            name: 'تاریخ ایجاد',
            cell: row => <div className="rahpardaznet-border">{moment(row.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
        },
        {
            name: 'تاریخ بروزرسانی',
            cell: row => <div className="rahpardaznet-border">{moment(row.updated_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
        },
        {
            name: 'عملیات',
            cell: row => <div className='rahpardaznet-table-btn'>  
                <span>
                    <a 
                        className='rahpardaznet-icon-table' 
                        onClick={(event) => editHandler(event.target.id, row.title, row.from, row.to)}
                        data-tooltip-id={"tooltip-edit-"+row.id}
                        data-tooltip-content='ویرایش زونکن '
                        data-tooltip-place="top"
                    >
                        <i className="fa-regular fa-pen-to-square fa-fw" id={row.id}></i>
                    </a>
                    <Tooltip id={"tooltip-edit-"+row.id} style={{ backgroundColor: "#767676", color: "#fff" }} />
                </span>
            </div>
        },
    ];
    const dispatch = useDispatch()
    const [page, setPage] = useState(1);
    const countPerPage = 20;
    const param = useParams()
    const token = localStorage.getItem('token')
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    let {
        message,
        sections, 
        previous,
        archiveSectionThreeLoading, 
        archiveSectionThreeSuccess,
        rahpardaznetLoading,
        CreateSectionThree,
        errorTitle
    } = useSelector(state => state.sectionThree)
    const [edit, setEdit] = useState()
    const [title, setTitle] = useState()
    const [Rahpardaznet_from, setRahpardaznet_from] = useState()
    const [Rahpardaznet_to, setRahpardaznet_to] = useState()
    
    const [name, setName] = useState()
    const [flag, setFlag] = useState()
    const [to, setTo] = useState()
    const [from, setFrom] = useState()
    const [modalShow, setModalShow] = useState(false)
    const editHandler = (id, name, from, to) => { 
        setEdit(id)
        setName(name)
        setFrom(from)
        setTo(to)
        setModalShow(true)
        
    }
    const updateHandler = (event) => {
        // console.log(event)
    }
    
    const closeButtonHandler = () => {
        setModalShow(false)
    }
    useEffect(() => {
        const data = {
            'section': param.section
        }
        dispatch(sectionIndex(data))
        console.log(sections)

        if(archiveSectionThreeSuccess === true && message != "") {
            toast.success(message, {
                position: "top-center",
                autoClose: 600,
            })
            setTitle('')
            setRahpardaznet_from('');
            setRahpardaznet_to('');
            message = ''
            getUserList()
        }
        message = ''
        return () => {
            message = ''
        }
    },[archiveSectionThreeSuccess, message])

    useEffect(() => {
      

        if(CreateSectionThree != "") {
            toast.success(CreateSectionThree, {
                position: "top-center",
                autoClose: 600,
            })
        }
      
    }, [CreateSectionThree])

    const getUserList = async (search = pinCode, pageNumber = page) => {

        const data = {
            'pageNumber': pageNumber,
            'countPerPage': countPerPage,
            'search': search,
            'section': param.section
        }
        dispatch(sectionIndex(data))

    };
    function searchByDataTable(event) {
        let delayTimeOutFunction;
        delayTimeOutFunction = setTimeout(() => {
            getUserList(event.target.value);


        }, 3000); // denounce delay

        return () => clearTimeout(delayTimeOutFunction);

    };
    const [pinCode, setPinCode] = useState("");
    useEffect(() => {
        getUserList()
    }, []);

    const rahkarpardaznet_search_datatable = (e) => {
        e.preventDefault();
        setPage(1);

        $('#pagination-first-page').trigger('click');
        getUserList(pinCode, 1);
    }

    const handlePageChange = (page) => {
        setPage(page);
        getUserList('', page);
    };


    useEffect(() => {
        if (rahpardaznetLoading) {
            $('.dlUCce').addClass('loading');
        } else {
            $('.dlUCce').removeClass('loading');
        }


        console.log(sections);

    }, [rahpardaznetLoading])
    const sectionThreeHandler = (event) => {

        const data = {
            'section_two_id': param.section,
            'title': title,
            'from': Rahpardaznet_from ? Rahpardaznet_from : '0',
            'to': Rahpardaznet_to ? Rahpardaznet_to : '0'
        }
        // Dispatch Data to Method SectionStore of ArchiveSectionThree Slice
        dispatch(sectionStore(data));
    }
    return (
        <>
        { archiveSectionThreeLoading === true ? (<Loading />) : null }
        <Broadcast title={'مدیریت بخش های انبار | بخش پایانی'} />
            <div className='row rahpardaznet-cart  my-5  print-position'>
                <Header title='افزودن انبار (بخش میانی)' />
            <div className='row'>
                <div className='col-12 d-flex'>
                    <div className="rahpardaz-search-form-select border-radius-0">
                    <Input
                        key='2'
                        tab='2'
                        col='col-12'
                        type='text'
                        maxlength={255}
                        name='number'
                        value={title}
                        title='عنوان'
                        onchange={(e) => setTitle(e.target.value)}
                        placeholder='مانند : ساختمان کویر موتور'
                        errorName={errorTitle}
                    />
                    <Input
                        key='2'
                        tab='2'
                        col='col-12'
                        type='text'
                        maxlength={255}
                        name='number'
                        value={Rahpardaznet_from}
                        title='عنوان'
                        onchange={(e) => setRahpardaznet_from(e.target.value)}
                        placeholder='از شماره سند'
                    />
                    <Input
                        key='2'
                        tab='2'
                        col='col-12'
                        type='text'
                        maxlength={255}
                        name='number'
                        value={Rahpardaznet_to}
                        title='عنوان'
                        onchange={(e) => setRahpardaznet_to(e.target.value)}
                        placeholder='تا شماره سند'
                    />
                    <Button
                        tab='3'
                        title='ثبت بخش پایانی'
                        design="rahpardaznet-search-btn"
                        event={sectionThreeHandler}
                    />
                    </div>





                </div>
            </div>
            </div>
                <div className='row g-2 pr-3 pl-3 pb-4'>

                    <div className="App">
                        <div className='row'>
                            <div className='col-12 col-md-6'>
                                <form onSubmit={rahkarpardaznet_search_datatable} className="rk-search-bar">
                                    <input type="text" id="" placeholder='جستجو کنید' onChange={(event) => setPinCode(event.target.value)} />
                                                               <button type="submit" ><Icon.Search /></button>

                                </form>                            </div>
                            <div className='col-12 col-md-6 text-left align-self-center'>
                                <Link to={`/dashboard/archive/section/two/index/${previous}`} className='rahpardaznet-btn-back'>برگشت</Link>
                            </div>
                        </div>

                        <DataTable
                            title=""
                            columns={columns}
                            data={(typeof sections == 'object') ? sections.data : []}
                            className='rahpardaznet-table-user'
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={(typeof sections == 'object') ? sections.total : []}
                            paginationPerPage={countPerPage}
                            paginationComponentOptions={{
                                noRowsPerPage: true
                            }}
                            onChangePage={handlePageChange}
                        />
                    </div>


                </div>
            <SectionThreeEditModel
                header='ویرایش  زونکن انبار'
                id={edit}
                title={name}
                from={from}
                to={to}
                // model='sectionThree'
                show={modalShow}
                onHide={() => closeButtonHandler()}
            />
        </>
    )
}

export default ArchiveSectionThreeIndex;